import { render, staticRenderFns } from "./DocsPanel.vue?vue&type=template&id=676a3db5&scoped=true&"
import script from "./DocsPanel.vue?vue&type=script&lang=js&"
export * from "./DocsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DocsPanel.vue?vue&type=style&index=0&id=676a3db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a3db5",
  null
  
)

export default component.exports